import Axios from '../utils/axios-utils';

// create Vendors
export const createVendors = async (data, accountId) => {
    try {
        const response = await Axios.post(`/accounts/${accountId}/vendors`, {
            name: data.name,
            category: data.category,
            location: data.location,
            address: data.address,
            city: data.city,
            state: data.state,
            country: data.country,
            postalCode: data.postalCode,
            note: data.note
        });

        return { success: response.data.status === 'success', data: response.data };
    } catch (error) {
        console.log("Create Vendors error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Create Vendors failed" }
        };
    }
};

// update Vendor
export const updateVendor = async (accountId, vendorId, data) => {
    try {
        const response = await Axios.patch(`/accounts/${accountId}/vendors/${vendorId}`, data);
        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Update Vendor error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Update Vendor failed" }
        };
    }
};

// delete Vendor
export const deleteVendor = async (accountId, vendorId) => {
    try {
        const response = await Axios.delete(`/accounts/${accountId}/vendors/${vendorId}`);
        return {
            success: response.data.status === 'success',
            data: response.data,
            status: response.status
        };
    } catch (error) {
        console.log("Delete vendor error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Delete vendor failed" },
            status: error.response?.status || 500
        };
    }
};

// get all vendors with page and limits
export const getAllVendors = async (accountId) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/vendors`);

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get All Vendors error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get All Vendors failed" }
        };
    }
};

// get all vendors list 
export const getAllVendorsMinimal = async (accountId) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/vendors/minimal`);

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get All Vendors error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get All Vendors failed" }
        };
    }
};

// update Vendor status
export const updateVendorStatus = async (accountId, vendorId, status) => {
    try {
        const response = await Axios.patch(`/accounts/${accountId}/vendors/${vendorId}/status`, {
            status,
        });

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Update Vendor Status error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Update Vendor Status failed" }
        };
    }
};

// get all Vendor statuses
export const getAllVendorStatuses = async (accountId) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/vendors/statuses`);

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get All Vendors statuses error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get All Vendors statuses failed" }
        };
    }
};
